import styled from "styled-components";

export const StyledQuestionReadyContent = styled.div`
  .question-detail-content {
    padding: 0;
    direction: rtl;
    border-radius: 10px;
    overflow: hidden;
  }

  .not-found-card {
    background: #f7f8fa;
    border: 1px solid #e6eaf5;
    border-radius: 10px;
    padding: 24px;
    text-align: center;
  }

  .not-found-title {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: #122243;
    margin: 0;
    margin-bottom: 8px;
  }

  .not-found-subtitle {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #7e8aad;
    margin: 0;
  }

  .note-input {
    width: 100%;
    border: none;
    background: transparent;
    text-align: center;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #122243;
    outline: none;
    padding: 2px 0;
    border-bottom: 1px dashed transparent;
    transition: all 0.2s ease;

    &:hover, &:focus {
      border-bottom-color: #7e8aad40;
    }

    &::placeholder {
      color: #7e8aad80;
    }
  }
`;
